import { createContext } from 'react';
import type { QuickHelpContextValue } from './types';

const QuickHelpContext = createContext<QuickHelpContextValue | null>(null);

export default QuickHelpContext;
